import type { FC } from 'react';
import type { ShopperProductsTypes } from 'commerce-sdk-isomorphic';
import { ClientOnly } from '../client-only/ClientOnly';
import { CategoryButtonTiles } from './CategoryButtonTiles';
import { CategoryImageTiles } from './CategoryImageTiles';

export type Category = ShopperProductsTypes.Category & {
    c_productInfoTile?: string[];
    c_template?: string;
    c_href: string;
    c_slotBannerImage: string;
};

export type CategoryTilesProps = {
    items: Category[];
    component: 'CATEGORY_BUTTON_TILES' | 'CATEGORY_IMAGE_TILES';
    dataTestId?: string;
};

const CategoryTiles: FC<CategoryTilesProps> = ({ items, component, dataTestId }) => {
    const hasMissingBannerImages =
        component === 'CATEGORY_IMAGE_TILES' &&
        items.some((item) => !item.c_slotBannerImage || item.c_slotBannerImage.trim() === '');

    if (component === 'CATEGORY_BUTTON_TILES' || hasMissingBannerImages) {
        return (
            <ClientOnly>
                <CategoryButtonTiles dataTestId={dataTestId} items={items} />
            </ClientOnly>
        );
    }

    if (component === 'CATEGORY_IMAGE_TILES') {
        return (
            <ClientOnly>
                <CategoryImageTiles dataTestId={dataTestId} items={items} />
            </ClientOnly>
        );
    }

    return null;
};

CategoryTiles.defaultProps = {
    dataTestId: undefined,
};

export { CategoryTiles };
